import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { BsFillLockFill } from 'react-icons/bs';

import * as S from './styles';
import LoginContext from 'context/LoginContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { UseTranslationProps } from 'types/UseTranslationProps';
import SimpleInput from 'components/SimpleInput';
import { png } from 'utils/imgList';
import Check from 'components/Buttons/Check';
import { color } from 'styles/pallete';
import { handleLoggin, handleDataUser } from './reqs';

export default function Login() {
	const navigate = useNavigate();
	const { t }: UseTranslationProps = useTranslation();
	const { setIsLogged } = useContext(LoginContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [email, setEmail] = useState<string>('');

	const [password, setPassword] = useState<string>('');
	const [rememberMe, setRememberMe] = useState<boolean>(false);
	const [errorForm, setErrorForm] = useState(false);

	async function handleLogin() {
		if (password === '' || email === '') {
			setErrorForm(true);
			return;
		}

		setErrorForm(false);

		setIsOpenLoad(true);
		setMessage('Validando acesso');
		//aqui busca primeiro o token
		const respStatus = await handleLoggin(
			{ email, password, type: 'basic' },
			setIsLogged,
			handleNotify,
			t
		);

		if (
			respStatus.isSuccess &&
			respStatus.tokens.access_token !== '' &&
			respStatus.tokens.refresh_token !== ''
		) {
			//aqui eu busco os dados do usuário
			const isSuccessGetUser = await handleDataUser(
				respStatus.tokens || null,
				setIsLogged,
				handleNotify,
				t
			);

			if (isSuccessGetUser) {
				navigate('/');
			}
		}

		setIsOpenLoad(false);
		setMessage('');
	}

	return (
		<S.container>
			<img src={png.logoPreta} alt="Logo Mondelez" />

			<S.loginBox>
				<h1> {t('login.title')}</h1>

				<SimpleInput
					label={t('login.emailAdress')}
					getValue={setEmail}
					placeHolder={t('login.emailPlaceHolder')}
					typeInput="email"
					initialValue={email}
					onPressEnter={handleLogin}
				/>

				<SimpleInput
					label={t('login.password')}
					getValue={setPassword}
					placeHolder={t('login.passWordPlaceHolder')}
					initialValue={password}
					typeInput="password"
					onPressEnter={handleLogin}
				/>

				<S.rememberMe style={{ display: 'none' }}>
					<Check
						isChecked={rememberMe}
						setIsChecked={setRememberMe}
						colorCheck={color.interface.blue1}
					/>
					<p>{t('login.rememberMe')}</p>
				</S.rememberMe>

				<S.btnLogin>
					<button onClick={handleLogin} type="submit">
						{t('login.btn')}
					</button>
				</S.btnLogin>
				{errorForm && <S.errorMessage>*{t('login.error')}</S.errorMessage>}
			</S.loginBox>

			{/* <S.forgotPassword>
				<BsFillLockFill color={color.interface.lightGray} />
				<p>{t('login.forgotPassword')}</p>
			</S.forgotPassword>

			<S.singUp>
				<p>{t('login.dontHaveAccount')}</p>
				<b>{t('login.singUp')}.</b>
			</S.singUp> */}
		</S.container>
	);
}
